export const AuthFieldsModel = [{
  key: 'email',
  order: 1,
  type: 'email',
  placeholder: 'Email'
}, {
  key: 'name',
  order: 2,
  type: 'name',
  placeholder: 'Name'
}, {
  key: 'firstName',
  order: 3,
  type: 'firstName',
  placeholder: 'registerScreen.placeholderFirstName'
}, {
  key: 'lastName',
  order: 4,
  type: 'lastName',
  placeholder: 'registerScreen.placeholderLastName'
}, {
  key: 'customer_id',
  order: 9,
  type: 'text',
  placeholder: 'registerScreen.placeholderCustomerId'
}, {
  key: 'street',
  order: 12,
  type: 'text',
  placeholder: 'registerScreen.placeholderStreet',
  identity: 'address'
}, {
  key: 'street_number',
  order: 13,
  type: 'text',
  placeholder: 'registerScreen.placeholderStreetNumber',
  identity: 'address'
}, {
  key: 'city_code',
  order: 11,
  type: 'text',
  identity: 'address',
  placeholder: 'registerScreen.placeholderCityCode'
}, {
  key: 'city',
  order: 10,
  type: 'text',
  identity: 'address',
  placeholder: 'registerScreen.placeholderCity'
}, {
  key: 'state',
  order: 14,
  type: 'text',
  identity: 'address',
  placeholder: 'registerScreen.placeholderState'
}, {
  key: 'country',
  order: 16,
  type: 'text',
  identity: 'address',
  placeholder: 'registerScreen.placeholderCountry',
}, {
  type: 'password',
  order: 5,
  placeholder: 'registerScreen.placeholderPassword',
  key: 'password'
}, {
  type: 'password',
  order: 6,
  placeholder: 'registerScreen.placeholderPasswordRepeat',
  key: 'passwordRepeat'
}, {
  key: 'gender',
  order: 7,
  type: 'radioselect',
  metadata: {
    choices: [{
        key: 1,
        text: 'registerScreen.placeholderGenderFemale',
        value: 'female'
      },
      {
        key: 2,
        text: 'registerScreen.placeholderGenderMale',
        value: 'male'
      },
      {
        key: 3,
        text: 'registerScreen.placeholderGenderOther',
        value: 'other'
      }
    ]
  }
}, {
  type: 'date',
  key: 'birthday',
  order: 8,
  icon: 'event',
  placeholder: 'registerScreen.placeholderBirthday',
  pastOnly: true,
  initialView: 'YEAR'
}, {
  key: 'phone',
  order: 15,
  type: 'text',
  placeholder: 'registerScreen.placeholderPhonenumber',
  rules: 'phoneNumber'
}, {
  key: 'terms_and_privacy',
  type: 'checkbox',
  name: 'terms_and_privacy'
}];
